/**
 * App.js Layout Start Here
 */
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';

// Theme provider
import RctThemeProvider from './RctThemeProvider';

// Layouts
import HorizontalLayout from './HorizontalLayout';
import AgencyLayout from './AgencyLayout';
import RctDefaultLayout from './DefaultLayout';
import RctBoxedLayout from './RctBoxedLayout';
import CRMLayout from './CRMLayout';

import Signin from './SigninFirebase';
import Signup from './SignupFirebase';
import ResetPassword from './ResetPassword';
import BusinessUnitSelector from './BusinessUnitSelector';
import CompanySelector from './CompanySelector';
import CheckoutSuccess from './CheckoutSuccess';
import CheckoutCancel from './CheckoutCancel';
import ForgotPassword from './ForgotPassword';
import AuthImpersonate from './AuthImpersonate';

// The app's authentication flow stores its bearer token in localStorage.
// A route guard is important because browser Back can revisit a previous SPA URL
// after logout even when the navigation to Sign In succeeded.
function hasActiveSession() {
   return Boolean(localStorage.getItem('token'));
}

function AuthenticatedRoute({ component: Component, ...rest }) {
   return (
      <Route
         {...rest}
         render={(routeProps) => hasActiveSession()
            ? <Component {...routeProps} />
            : <Redirect to="/signin" />
         }
      />
   );
}

function App(props) {
   const { location } = props;
   const isAuthenticated = hasActiveSession();

   const basePath = process.env.PUBLIC_URL;

   const normalizedAccess = String(localStorage.getItem('access') || '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');

   const defaultAuthenticatedPath = normalizedAccess === 'superuser'
      ? `${basePath}/app/dashboard/hr-analytics/overview`
      : `${basePath}/app/dashboard/ecommerce`;

   if (
      location.pathname === '/' ||
      location.pathname === `${basePath}/`
   ) {
      return (
         <Redirect to={isAuthenticated ? defaultAuthenticatedPath : `${basePath}/signin`} />
      );
   }

   return (
      <RctThemeProvider>
         <NotificationContainer />
         <Switch>
            <Route path={`${basePath}/signin`} component={Signin} />
            <Route path={`${basePath}/signup`} component={Signup} />
            <Route path={`${basePath}/reset-password`} component={ResetPassword} />
            <AuthenticatedRoute path={`${basePath}/choose-business-unit`} component={BusinessUnitSelector} />
            <AuthenticatedRoute path={`${basePath}/choose-company`} component={CompanySelector} />
            <AuthenticatedRoute path={`${basePath}/app`} component={RctDefaultLayout} />
            <AuthenticatedRoute path={`${basePath}/horizontal`} component={HorizontalLayout} />
            <AuthenticatedRoute path={`${basePath}/agency`} component={AgencyLayout} />
            <AuthenticatedRoute path={`${basePath}/boxed`} component={RctBoxedLayout} />
            <AuthenticatedRoute path={`${basePath}/dashboard`} component={CRMLayout} />
            <Route path={`${basePath}/checkout-success`} component={CheckoutSuccess} />
            <Route path={`${basePath}/checkout-cancel`} component={CheckoutCancel} />
            <Route path={`${basePath}/forgot-password`} component={ForgotPassword} />
            <Route path={`${basePath}/auth/impersonate`} component={AuthImpersonate} />
         </Switch>
      </RctThemeProvider>
   );
}

export default App;
